export default function ($translate) {
    return {
        KEYS: {
            ALL_SITES: 'ALL_SITES',
            SPECIFIED_SITES: 'SPECIFIED_SITES'
        },
        LABELS: {
            ALL_SITES: $translate.instant('course.All sites'),
            SPECIFIED_SITES: $translate.instant('course.Specified sites')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/siteAccess/index.js